import petalImg from "../../img/momsday/petal.png";

const PETALS = Array.from({ length: 14 });

const FallingPetals = () => {
  return (
    <div className="md-petals-layer" aria-hidden="true">
      {PETALS.map((_, i) => {
        const left     = Math.random() * 100;
        const size     = 18 + Math.random() * 28;
        const duration = 14 + Math.random() * 16;
        const delay    = Math.random() * 20;
        const opacity  = 0.35 + Math.random() * 0.4;
        return (
          <img
            key={i}
            src={petalImg}
            alt=""
            className="md-animate-drift"
            style={{
              left:              `${left}%`,
              width:             `${size}px`,
              height:            `${size}px`,
              animationDuration: `${duration}s`,
              animationDelay:    `${delay}s`,
              opacity,
            }}
          />
        );
      })}
    </div>
  );
};

export default FallingPetals;
